module.exports = __webpack_public_path__ + "static/0057-2a2598e3b0fad5b7148bac3e5ad7e502.png";